module.exports = __webpack_public_path__ + "static/media/19.13b7f6f9.jpg";